<template>
  <div class="bg-color-white h-full">
    <!-- 상단 고정 캠페인 배너 -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>

    <NoData v-if="isNoData"></NoData>

    <div class="pdb-50" v-if="itemDetails">
      <div class="mgt-16">
        <div id="tab1" class="scroll-y mgb-40 bg-color-white">
          <img
            :src="
              itemDetails.thumbnail.resourceUri
                ? itemDetails.thumbnail.resourceUri
                : 'images/prize_request/dummImage.png'
            "
            alt=""
          />
          <div
            class="t-color-title t-subtitle2 l-spacing48 pdl-16 pdb-16 pdr-16 pdt-16 font-b"
          >
            {{ itemDetails.name }}
          </div>
          <div class="d-flex align-items-center">
            <div class="pdr-3 t-body3 t-color-title">
              <span
                class="listPointIcon d-flex justify-content-center align-items-center t-color-white bg-textField2 mgr-4 pdt-2 t-body4"
                >P</span
              >
            </div>
            <div class="t-headline5 t-color-title d-flex align-items-center">
              <div class="mgr-8">
                <img
                  src="images/prize_request/p-image.svg"
                  class="w-24 h-24"
                  alt=""
                />
              </div>
              {{ itemDetails.price }}
            </div>
          </div>

          <div
            class="pdl-16 pdr-16 pdt-17 pdb-16"
            v-if="itemDetails.status && itemDetails.status.value == 'SOLD_OUT'"
          >
            <a
              @click="outofStockAlert"
              class="d-block btn-disable t-center pdt-11 pdb-10 t-color-white b-radius4 b-shadow2 t-body2"
              >{{ $t("1979") }}</a
            >
          </div>
          <div class="pdl-16 pdr-16 pdt-17 pdb-16" v-else>
            <div
              @click="showModal(!showModalCss)"
              class="d-block btn-red t-center pdt-11 pdb-10 t-color-white b-radius4 b-shadow2 t-body2"
            >
              {{ $t("1979") }}
            </div>
          </div>

          <div v-for="(images, index) in itemDetails.images" :key="index">
            <img :src="images.resourceUri" :alt="itemDetails.name" />
          </div>

          <!-- <img src="images/prize_request/dummImage.png" alt="" /> -->
        </div>
        <div
          class="w-full h-full"
          :class="bg_overlay"
          @click.prevent="showModalCss ? hideModel(showModalCss) : ''"
        ></div>

        <!-- 모달 -->
        <div id="modal1" class="modal bottom-sheet modal-display w-full">
          <div class="modal-content pda-0 bg-gray">
            <div class="pdl-16 pdr-16 pdt-16 pdb-50 mgb-50">
              <div class="t-color-title t-body3 l-spacing42 font-r">
                {{ itemDetails.name }}
              </div>
              <div
                class="qtyWrapper bg-white mgt-16 pdl-16 pdr-16 pdt-16 pdb-16 d-flex justify-content-between align-items-center"
              >
                <div class="t-color-content1 t-body3 l-spacing42 font-r">
                  {{ $t("1980") }}
                </div>
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="images/prize_request/minus.svg"
                      alt=""
                      @click="decQty"
                    />
                  </div>
                  <div class="w-50 t-center t-color-title t-subtitle6">
                    {{ qty }}
                  </div>
                  <div>
                    <img
                      src="images/prize_request/plus.svg"
                      alt=""
                      @click="incQty"
                    />
                  </div>
                </div>
              </div>
              <div
                class="pdt-16 pdb-16 d-flex justify-content-between align-items-center"
              >
                <div class="d-flex">
                  <div class="t-color-content1 t-body3 l-spacing42 font-r">
                    {{ $t("1981") }}
                  </div>
                </div>
                <div class="d-flex align-items-center price-left qty">
                  <div class="pdl-16 pdr-3 t-body3 t-color-title">
                    <div class="mgr-8">
                      <img
                        src="images/prize_request/p-image.svg"
                        class="w-24 h-24"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="t-headline5 t-color-title">
                    {{ itemDetails.price * qty }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="footer-tag bg-white fixed-bottom">
            <div class="d-flex pdt-10 pdb-44 pdr-16 justify-content-between">
              <div class="d-flex align-items-center price-left qty">
                <!-- <div class="pdl-16 pdr-3 t-body3 t-color-title">
                  <div class="mgr-8">
                    <img
                      :src="
                        itemDetails.thumbnail.resourceUri
                          ? itemDetails.thumbnail.resourceUri
                          : 'images/prize_request/p-image.svg'
                      "
                      class="w-24 h-24"
                      alt=""
                    />
                  </div>
                </div>
                <div class="t-headline5 t-color-title">
                  {{ itemDetails.price }}
                </div> -->
              </div>
              <div
                v-if="
                  itemDetails.status && itemDetails.status.value == 'SOLD_OUT'
                "
              >
                <a
                  @click="outofStockAlert"
                  class="d-block btn-disable t-center pdt-9 pdb-7 pdl-16 pdr-16 t-color-white b-radius4 b-shadow2 t-body2 modal-trigger"
                  >{{ $t("1979") }}</a
                >
              </div>

              <div v-else-if="purchaseButton === false">
                <a
                  @click="showModal(!showModalCss)"
                  class="d-block btn-red t-center pdt-9 pdb-7 pdl-16 pdr-16 t-color-white b-radius4 b-shadow2 t-body2 modal-trigger"
                  >{{ $t("1979") }}</a
                >
              </div>

              <div v-else>
                <a
                  @click="moveToInformation(itemDetails.id)"
                  class="d-block btn-red t-center pdt-9 pdb-7 pdl-16 pdr-16 t-color-white b-radius4 b-shadow2 t-body2 modal-trigger"
                  >{{ $t("1979") }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <infinite-loading
        @infinite="fetchData"
        :identifier="infiniteId"
        spinner="spiral"
      >
        <div slot="no-more" class="mgt-16">No more data</div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading> -->
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";

import { MDCRipple } from "@material/ripple";
import prizeRequestApi from "@/api/prizeRequestApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoData.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    ListItem,
    NoData,
    InfiniteLoading,
    TopAppBar,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      showModalCss: false,
      prize_id: "",
      itemDetails: null,
      qty: 1,
      purchaseButton: false,
      bg_overlay: "",
      inStock: 0,
      user_points: localStorage.getItem("user_point"),
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarBack(this.$t("1975"));
    this.prize_id = this.$route.params.prizeid;
    this.fetchData();
  },

  methods: {
    showModal(showModalCss) {
      console.log("CLICK", showModalCss);
      this.purchaseButton = this.purchaseButton ? false : true;

      if (showModalCss) {
        document.querySelectorAll("#modal1")[0].style.display = "block";
        this.bg_overlay = "bg-overlay";
      } else {
        document.querySelectorAll("#modal1")[0].style.display = "none";
        this.bg_overlay = "";
      }

      this.showModalCss = showModalCss;
    },

    fetchData() {
      let responseData = null;
      prizeRequestApi
        .prizeProductDetails(this.prize_id)
        .then((response) => {
          // console.log("response.data.data", response.data.data);
          this.itemDetails = response.data.data;
          if (
            response.data.data.salesQuantity < response.data.data.soldQuantity
          ) {
            this.inStock = response.data.data.salesQuantity;
          } else {
            this.inStock =
              response.data.data.salesQuantity -
              response.data.data.soldQuantity;
          }
        })
        .catch((err) => {});
    },
    incQty() {
      if (this.qty >= this.inStock) {
        this.outofStockAlert();
      } else {
        this.qty += 1;
      }
    },
    decQty() {
      this.qty !== 1 ? (this.qty -= 1) : this.qty;
    },
    moveToInformation(pid) {
      let total_cost = this.qty * this.itemDetails.price;
      if (total_cost > this.user_points) {
        this.insufficientPointsAlert();
      } else {
        this.$router.push({
          name: "PurchaseDetails",
          params: { prizeid: pid, qty: this.qty },
        });
      }
    },
    outofStockAlert() {
      this.$alert({
        title: this.$t("3000"), //가입 승인 대기 상태입니다.
        content: this.$t("3001"),
        accept: this.$t("3002"),
      });
    },
    insufficientPointsAlert() {
      this.$alert({
        // title: this.$t("3000"), //가입 승인 대기 상태입니다.
        content: this.$t("S20041"),
        accept: this.$t("S20042"),
      });
    },
    hideModel(showModalCss) {
      document.querySelectorAll("#modal1")[0].style.display = "none";
      this.bg_overlay = "";
      this.purchaseButton = false;
      this.showModalCss = false;
    },
  },
};
</script>



<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}
.tabs .indicator {
  background: #2d6dcc;
}
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.mgb-100 {
  margin-bottom: 100px !important;
}
.footer-tag {
  box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.5);
  bottom: 0;
  z-index: 9999;
}
.bg-blue1 {
  background: #2d6dcc !important;
}
.qtyWrapper {
  border: solid 1px #dbdbdb;
}
.modal.bottom-sheet {
  max-height: 50% !important;
  transition: all 300ms ease-in-out;
}
.modal-display {
  display: none;
  position: fixed;
  bottom: -2px;
  z-index: 99;
}
.bg-overlay {
  position: fixed;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9;
  top: 0;
}
.btn-disable {
  background-color: #dbdbdb;
  color: #9a9a9a;
}
</style>